// this is the only place bluebird is allowed to be imported
/* eslint-disable-next-line no-restricted-imports */
import bluebird from 'bluebird';

bluebird.config({
  warnings: false,
  longStackTraces: false,
});

export default bluebird;
